function theExcerpt(content, link, amount = 12, text = 'Read More') {
  const divider = content.length > amount ? '<span class="excerpt-divider">...</span>' : '';

  content = content.replace('[&hellip;]', `...`);
  content = content.split(' ').splice(0, amount).join(' ');
  return content;
}

export default theExcerpt;